import { render, staticRenderFns } from "./ModalMinutagem.vue?vue&type=template&id=b31bdd9e&scoped=true&"
import script from "./ModalMinutagem.vue?vue&type=script&lang=js&"
export * from "./ModalMinutagem.vue?vue&type=script&lang=js&"
import style0 from "./ModalMinutagem.vue?vue&type=style&index=0&id=b31bdd9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31bdd9e",
  null
  
)

export default component.exports